import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  card: {
    backgroundColor: theme.palette.backGroundItem?.card || theme.palette.background.paper,
    margin: theme.spacing(2, 0),
    padding: theme.spacing(3),
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      margin: theme.spacing(1.5, 0),
    },
  },
  vestigioHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  vestigioIndicator: {
    width: '3px',
    height: '18px',
    borderRadius: '1.5px',
    background: `linear-gradient(180deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.light})`,
    marginRight: theme.spacing(1.2),
  },
  vestigioTitle: {
    fontWeight: 700,
    fontSize: '0.925rem',
    color: theme.palette.text.primary,
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
  infoContainer: {
    padding: theme.spacing(0, 1, 2, 1),
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1.5),
  },
  infoLabel: {
    fontSize: '11px',
    fontWeight: 700,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0.5),
    letterSpacing: '0.2px',
  },
  infoValue: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  },
  technicalSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 1),
  },
  technicalTitle: {
    fontWeight: 700,
    fontSize: '0.85rem',
    color: theme.palette.text.secondary,
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  technicalDivider: {
    marginBottom: theme.spacing(1.5),
  },
}))

export default useStyles
